import { render, staticRenderFns } from "./SupplierPortalOffersInvoicesDialog.vue?vue&type=template&id=18b70b90"
import script from "./SupplierPortalOffersInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./SupplierPortalOffersInvoicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports